module.exports = __webpack_public_path__ + "img/Yukai.d55a3ef4.jpeg";